import React from 'react';
import ToSustainabilityCategoryDetails from "@product/features/sustainability/ToSustainabilityCategoryDetails.jsx";
import SustainabilityGoal from "@product/features/sustainability/SustainabilityGoal.jsx";
import SustainabilityIntroduction from "@product/features/sustainability/SustainabilityIntroduction.jsx";
import SustainabilityCategories from "@product/features/sustainability/SustainabilityCategories.jsx";
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import SustainabilityCategoryDetails from "@product/features/sustainability/SustainabilityCategoryDetails.jsx";
import {SideSectionAction} from "@product/sections/SideSectionAction.tsx";
import {SustainabilityStandardDetailLandmark} from "@product/landmarks/landmarks.ts";
import {sendLandmark} from "@product/landmarks/landmark-delegate.ts";
import SustainabilityCircularityID from "@product/features/sustainability/SustainabilityCircularityID.jsx";


export default function Sustainability({sustainabilityContext, glossaryData}) {

    if (!sustainabilityContext) {
        return <></>;
    }

    const {categories, staticLinks, contentElements, selectedItemNumber} = sustainabilityContext;

    function onToSustainabilityCategoryDetailsClicked() {
        const detailsComponent = <SustainabilityCategoryDetails categories={categories}/>;
        sendLandmark(new SustainabilityStandardDetailLandmark());
        MessageBroker.publish(SideSectionAction.OPEN, {
            nodes: {
                title: contentElements.toCategoryDetails,
                content: detailsComponent
            },
            back: content
        });
    }

    const content = (
        <div className="sustainability">
            <div className="sustainability-introduction-wrapper">
                <SustainabilityIntroduction text={contentElements.sustainabilityIntroduction}/>
            </div>
            <div className={"sustainability-categories-wrapper"}>
                <SustainabilityCategories categories={categories}
                                          glossaryContent={glossaryData}/>
            </div>
            <div className={"sustainability-to-category-details-wrapper"}>
                <ToSustainabilityCategoryDetails
                    text={contentElements.toCategoryDetails}
                    onClick={onToSustainabilityCategoryDetailsClicked}/>
            </div>
            {sustainabilityContext.circularityIdLink && (<SustainabilityCircularityID href={sustainabilityContext.circularityIdLink}/>)}
            <div className={"sustainability-goal-wrapper"}>
                <SustainabilityGoal
                    productContext={{itemNumber: selectedItemNumber}}
                    introduction={contentElements.sustainabilityGoalIntroduction}
                    readMoreUrl={staticLinks.sustainabilityGoalLink}
                    readMoreText={contentElements.sustainabilityGoalLink}/>
            </div>
        </div>
    );

    return content;
}
